import React from "react";
//outsource
import { Row, Col, Input, InputNumber, Button, Checkbox } from "antd";
import { CloseOutlined } from "@ant-design/icons";
//components

const CardRedeemNote = ({ edit, data, handleChange, handleRemoveNote }) => {
  // -------------------------- VAR --------------------------
  const note = data?.note;
  const value = data?.value;
  const dataIndex = data?.dataIndex;
  const refund = data?.refund;

  const disabled = refund ? true : !edit;
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------
  const handleNote = (e) => {
    const value = e?.target?.value;
    handleChange(dataIndex, "note", value);
  };

  const handleNumber = (value) => {
    handleChange(dataIndex, "value", value);
  };

  const handleCheckbox = (e) => {
    const value = e.target.checked;
    handleChange(dataIndex, "refund", value);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Row gutter={[10, 10]} key={dataIndex} className="card-note">
      <Col span={16}>
        <Input
          disabled={disabled}
          defaultValue={note}
          onChange={handleNote}
          placeholder="Note"
        />
      </Col>
      <Col span={6}>
        <InputNumber
          min={0}
          prefix="$"
          disabled={disabled}
          placeholder="Amount"
          defaultValue={value}
          onChange={handleNumber}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
        />
      </Col>
      <Col span={2}>
        <Button
          type="text"
          shape="circle"
          disabled={disabled}
          onClick={() => handleRemoveNote(dataIndex)}
          icon={<CloseOutlined style={{ color: "red", fontSize: 20 }} />}
        />
      </Col>
    </Row>
  );
};

export default CardRedeemNote;